"use client";

import Image from "next/image";
import { ArrowDown } from "react-feather";

interface Props {
	jumpToForm?: boolean;
	style?: React.CSSProperties;
}

export const Scroll = ({ jumpToForm, style }: Props) => {
	const onScroll = () => {
		if (jumpToForm) {
			const formElement = document.getElementById("trainers-form");
			if (formElement) {
				const yOffset = -128;
				const y =
					formElement.getBoundingClientRect().top +
					window.pageYOffset +
					yOffset;
				window.scrollTo({ top: y, behavior: "smooth" });
			}
			return;
		}

		// scroll 100vh down
		window.scrollTo({
			top: window.innerHeight - 128,
			behavior: "smooth",
		});
	};

	return (
		<div className="grabber__scroll" onClick={onScroll} style={style}>
			<Image
				unoptimized
				src="/images/svg/blob.svg"
				alt="scroll"
				width={96}
				height={96}
				className="grabber__scroll__image"
				style={{
					position: "absolute",
					transform: "rotate(120deg)",
				}}
			/>
			<div className="grabber__scroll__icon">
				<ArrowDown size={36} />
			</div>
		</div>
	);
};
